import * as React from "react";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { InstrumentSelection } from "../../../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelection";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { processTypeEnum } from "../../Resource/Contents";
import { DocumentsToSend } from "./DocumentsToSend";
import { InvestmentDocuments } from "./InvestmentDocuments";
import { QuoteAndCharges } from "./QuoteAndCharges";
import { InstructionStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { Illustrations } from "./Illustrations";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";

interface IDocumentsProps extends IProcessComponentProps {
    data:
        | ApplyModel
        | GiaContributionModel
        | IsaContributionModel
        | PensionContributionModel
        | WrapCashContributionModel;
    processType: processTypeEnum;
    subAccountType: SubAccountType;
    needGoToDlu: boolean;
    clAccountId?: string;
    buyAllocations?: InvestmentAllocation[];
    onTasksForEsign: (newTask) => void;
}

interface IDocuments {
    selectAll: boolean;
    triggerred: number;
}

export class Documents extends ProcessComponent<IDocumentsProps, IDocuments> {
    constructor(props: IDocumentsProps) {
        super(props);
        this.state = {
            selectAll: false,
            triggerred: 0,
        };
    }

    render() {
        return (
            <>
                <h2>Documents</h2>
                {!this.IsInstructionCompleted() && (<CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Select all documents",
                            disabled: this.props.isReview,
                            value: this.state.selectAll,
                            onChange: (v) => {
                                this.setState({ selectAll: v });
                            },
                        },
                    ]}
                />)}
                <QuoteAndCharges
                    {...this.props}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    hideCheckbox={this.IsInstructionCompleted()}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <DocumentsToSend
                    {...this.props}
                    onRef={(ref) => this.appendChild(ref)}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    onTasksForEsign={(val) => this.props.onTasksForEsign(val)}
                    readonly={this.IsInstructionCompleted()}
                    hideCheckBox={this.IsInstructionCompleted()}
                    isReview={false}
                />
                <InvestmentDocuments
                    {...this.props}
                    onRef={(ref) => this.appendChild(ref)}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    hideCheckBox={this.IsInstructionCompleted()}
                />
                <Illustrations
                    {...this.props}
                    selectAll={this.state.selectAll}
                    triggerred={this.state.triggerred}
                    hideCheckbox={this.IsInstructionCompleted()}
                    onRef={(ref) => this.appendChild(ref)}
                />
                {!this.IsInstructionCompleted() && (<div>
                    <button
                        className="btn primary"
                        onClick={(e) => {
                            e.preventDefault();
                            this.setState({ triggerred: this.state.triggerred + 1, selectAll: false });
                        }}
                    >
                        Generate document(s)
                    </button>
                </div>)}
            </>
        );
    }

    private IsInstructionCompleted(): boolean
    {
        return this.props.data != undefined && (this.props.data.Status == InstructionStatus.Complete || this.props.data.Status == InstructionStatus.Submitted);
    }
}
